import React, { Component } from "react"
import Loader from "ui-Loader"

export default function asyncComponent(getComponent, options = {}) {
  const instances = []
  let loading

  function loadComponent() {
    if (loading) {
      return loading
    }

    loading = getComponent()
      .then(({ default: Component }) => {
        if (options.component) {
          Component = options.component(Component)
        }

        dynamic.Component = Component

        return Component
      })
      .catch(error => {
        console.error(error) // eslint-disable-line
      })
      .then(Component => {
        loading = null
        return Component
      })

    return loading
  }

  const dynamic = class AsyncComponent extends Component {
    static Component = null

    state = { Component: AsyncComponent.Component }

    componentDidMount() {
      if (!this.state.Component) {
        if (options.loader) {
          this._loadDelay = setTimeout(() => this.setState({ loadSlow: true }), options.delay)
        }

        loadComponent().then(Component => {
          this.setState({ Component })
          if (this._loadDelay) {
            clearTimeout(this._loadDelay)
          }
        })
      }

      if (module.hot) {
        instances.push(this)
      }
    }

    componentWillUnmount() {
      if (module.hot) {
        const index = instances.indexOf(this)
        instances.splice(index, 1)
      }
    }

    render() {
      const { Component } = this.state

      if (Component) {
        return <Component {...this.props} />
      }

      if (options.delay && !this.state.loadSlow) {
        return null
      }

      return options.loader || null
    }
  }

  if (module.hot) {
    // The component that uses the async component must use module.hot.accept
    // and use this method as the callback to force components to reload on hot
    // load.
    dynamic.HandleHot = () => {
      loadComponent().then(Component => instances.forEach(c => c.setState({ Component })))
    }
  }

  return dynamic
}

export function asyncComponentWithLoader(getComponent, options = {}) {
  return asyncComponent(getComponent, {
    delay: 1000,
    loader: <Loader appearance="table" />,
    ...options,
  })
}



// WEBPACK FOOTER //
// ../ui-kit/src/components/asyncComponent.js